import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledAppDetail = styled(Box)`
  background-color: ${COLOR.white[100]};
  border-radius: 12px;

  .title-app-box {
    display: flex;
    gap: 8px;
    padding: 16px;
    align-items: center;
    max-width: 500px;
    font-size: 24px;

    .title-app {
      max-width: 500px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
  }

  .content {
    display: flex;
    padding: 16px;
    position: relative;

    .sidebar-box {
      min-width: 200px;
      display: flex;
      flex-direction: column;
      gap: 32px;
      background-color: ${COLOR.ink[4]};
      border-radius: 12px;
      padding: 16px 12px;
      position: sticky;
      top: 16px;
      height: fit-content;

      .text-item {
        font-weight: 500;
        cursor: pointer;
        margin-top: 8px;
        max-width: 200px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        width: max-content;

        &:hover {
          color: ${COLOR.primary.base};
        }
      }
    }
  }
`;
